import { Breadcrumbs } from "../../Home/Breadcrumb"
import { BuscarArea } from "./Buscar";
import TableArea from "./Table";
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";
import { useArea } from "../../../hooks/useArea";


export const Areas = () => {
    const { guardado, handleGuardado } = useArea();

    useEffect(() => {
        if (guardado) {
            toast.success("Se guardó el Área correctamente");
            handleGuardado(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <ToastContainer />

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <Breadcrumbs
                            title={'Áreas'}
                            nameFirst={'Configuración'}
                            urlFirst={'/'}
                        />

                        <BuscarArea />
                        <TableArea />

                    </div>
                </div >
            </div >
        </>
    )
}
